import { getController, apiService as Service } from '@/services/service'

const url = 'documenttypes'

export const documentTypeService = {
	...getController<
		Api.DocumentType,
		Api.DocumentTypePostInput,
		Api.DocumentTypeUpdateInput
	>(url),
	// index: (pageNum: number, data?: HpRequestOptional) => //TODO check if realy needed with
	// 	Service.get<Api.Collection<Api.DocumentType>>({
	// 		url: `${url}?of=name&od=ASC&pageSize=150&pageNum=${pageNum}`,
	// 		...data,
	// 	}),
	searchAcronym: (acronym: string) =>
		Service.get<Api.Collection<unknown>>({
			url: `${url}?q[]=acronym&v[]=${acronym}&sm=1`,
		}),
	bulkCutoff: (data: Api.DocumentTypeBulkCutoffInput) =>
		Service.post<unknown>({
			url: `${url}/cutoff`,
			data,
		}),
	bulkUpdate: (data: Api.DocumentTypeBulkUpdateInput) =>
		Service.post<unknown>({
			url: `${url}/bulk`,
			data,
		}),
}

export default documentTypeService
